import { render, staticRenderFns } from "./doubleMajorPreference.vue?vue&type=template&id=97a8def2"
import script from "./doubleMajorPreference.vue?vue&type=script&lang=js"
export * from "./doubleMajorPreference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports